// Libs
import React, { useRef, useState, useEffect } from 'react'
// Local
import Router from 'components/router';
// Styles
import 'App.scss'

export default function App() {
  return (
    <>
      <div className="App">
        <Router />
      </div>
    </>
  );
}